import React from "react";
import Rocket from "../static/rocket.svg";

const Header = () => (
  <div id="header" className="section">
    <div className="brand">
      <div className="brand-header">
        <div className="brand-title">Yet Another Startup</div>
        <div className="brand-desc">
          You just got another startup/product idea but worried about software?
          Well, we are here to help! We specialize in making modern, catchy and
          performant web applications leveraging the latest of React, Node.js,
          Django, Flask and OpenSource. We also develop Android and iOS
          applications on demand. Let’s make your next adventure a great
          experience!
        </div>
        <div className="btn-group">
          <button className="btn-dark">Learn more</button>
          <button className="btn-brand">Get in touch</button>
        </div>
      </div>
      <div className="brand-illustration">
        <img src={Rocket} alt="Product launch" className="illustration" />
      </div>
    </div>
  </div>
);

export { Header };
